import React from "react";
import "./Footer.css"; // Import the custom CSS file
import { FaStore } from "react-icons/fa"; // Import FontAwesome icon
import CurrencyDropdown from "../CurrencyDropdown/CurrencyDropdown";
import { useSelector } from "react-redux"; 

const Footer = () => {
  const sellerName = useSelector((state) => state.fetchUser?.user?.username); 
  const createdYear = useSelector((state) => state.fetchUser?.user?.createdYear);
  const updatedYear = useSelector((state) => state.fetchUser?.user?.updatedYear);
  const currentYear = new Date().getFullYear(); // Get the current year

  const displayYear = createdYear || updatedYear || currentYear; // Use createdYear, fallback to updatedYear, then currentYear

  return (
    <>
      <footer className="footer" id="footer">
        <p className="footer-text">
          © {displayYear} by {sellerName || "SocioShop"}. All rights reserved.
        </p>
        <div className="footer-upgrade">
          <FaStore className="footer-icon" />
          <span className="footer-upgrade-text">Upgrade to #SocioShop™</span>
        </div>
      </footer>

      {/* <div className="currancydropdownmenu">
        <CurrencyDropdown />
      </div> */}
    </>
  );
};

export default Footer;